export default __webpack_public_path__ + "static/media/No.6-2.cbf2bafe.jpg";